<template>
  <div class="email-search">
    <InputText v-model="searchTerm" placeholder="Buscar Pregunta" @input="emitSearch" />
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  props: {
    modelValue: String,
  },
  setup(props, { emit }) {
    const searchTerm = ref(props.modelValue);

    const emitSearch = () => {
      emit('update:modelValue', searchTerm.value);
      emit('search-results', searchTerm.value); // Emitir resultados de búsqueda
    };

    return {
      searchTerm,
      emitSearch,
    };
  },
};
</script>

<style scoped>
.email-search {
  margin-bottom: 1rem;
}
</style>